var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarservices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3939 52.5552H10.1613C5.09968 52.5552 1 48.4555 1 43.3939V10.1613C1 5.09968 5.09968 1 10.1613 1H43.3939C48.4555 1 52.5552 5.09968 52.5552 10.1613V43.3939C52.5552 48.444 48.444 52.5552 43.3939 52.5552Z",
    fill: "#F2FFFA",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8702 26.5303H23.9688V27.674H29.8702V26.5303Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5742 27.6731H37.2704V26.5294H38.5742C38.9631 26.5294 39.2833 26.2092 39.2833 25.8203V20.7881C39.2833 20.4221 38.9974 20.1476 38.6428 20.1476H18.2852V19.0039H38.6428C39.6264 19.0039 40.427 19.8045 40.427 20.7881V25.8317C40.427 26.8496 39.5921 27.6731 38.5742 27.6731Z",
    fill: "#09081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.502 27.6735H17.0038C16.1232 27.6735 15.4141 26.9644 15.4141 26.0838V19.5762H16.5578V26.0838C16.5578 26.3354 16.7522 26.5298 17.0038 26.5298H18.502V27.6735Z",
    fill: "#09081A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5544 20.1481H18.2847V19.0044H33.553L30.8882 14.5097C30.7509 14.2809 30.5108 14.1437 30.2477 14.1437H16.8665C16.695 14.1437 16.5578 14.2809 16.5578 14.4525V19.5648H15.4141V14.4525C15.4141 13.6519 16.066 13 16.8665 13H30.2592C30.9225 13 31.5401 13.3545 31.8718 13.915L35.5544 20.1481Z",
    fill: "#09081A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2347 30.2125C19.4048 30.2125 17.918 28.7257 17.918 26.8958C17.918 25.0659 19.4048 23.5791 21.2347 23.5791C23.0646 23.5791 24.5514 25.0659 24.5514 26.8958C24.5514 28.7257 23.0646 30.2125 21.2347 30.2125ZM21.2347 24.7228C20.0338 24.7228 19.0617 25.6949 19.0617 26.8958C19.0617 28.0967 20.0338 29.0688 21.2347 29.0688C22.4355 29.0688 23.4077 28.0967 23.4077 26.8958C23.4077 25.6949 22.4241 24.7228 21.2347 24.7228Z",
    fill: "#09081A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5472 30.2125C32.7173 30.2125 31.2305 28.7257 31.2305 26.8958C31.2305 25.0659 32.7173 23.5791 34.5472 23.5791C36.3771 23.5791 37.8639 25.0659 37.8639 26.8958C37.8639 28.7257 36.3771 30.2125 34.5472 30.2125ZM34.5472 24.7228C33.3463 24.7228 32.3742 25.6949 32.3742 26.8958C32.3742 28.0967 33.3463 29.0688 34.5472 29.0688C35.748 29.0688 36.7202 28.0967 36.7202 26.8958C36.7202 25.6949 35.748 24.7228 34.5472 24.7228Z",
    fill: "#09081A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5569 24.0935H14.3953C13.629 24.0935 13 23.4644 13 22.6982V18.741C13 17.9747 13.629 17.3457 14.3953 17.3457H16.5569V24.0935ZM14.3953 18.5008C14.2581 18.5008 14.1437 18.6038 14.1437 18.741V22.6982C14.1437 22.8354 14.2581 22.9498 14.3953 22.9498H15.4132V18.5008H14.3953Z",
    fill: "#09081A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6867 13.5723H26.543V19.5766H27.6867V13.5723Z",
    fill: "#09081A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9328 13.5723H20.7891V19.5766H21.9328V13.5723Z",
    fill: "#09081A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8548 21.0518H37.293V22.1954H39.8548V21.0518Z",
    fill: "#09081A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1902 39.3164H18.5938V40.4601H37.1902V39.3164Z",
    fill: "#09081A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1582 40.4604H25.6406V32.5117H30.1582V40.4604ZM26.7843 39.3167H29.0145V33.6554H26.7843V39.3167Z",
    fill: "#09081A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5344 33.0841H25.2506C24.6558 33.0841 24.1641 32.6038 24.1641 31.9976C24.1641 31.4029 24.6444 30.9111 25.2506 30.9111H30.5344C31.1291 30.9111 31.6209 31.3915 31.6209 31.9976C31.6209 32.5924 31.1406 33.0841 30.5344 33.0841Z",
    fill: "#05D484"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.455 33.6556H25.3313C24.3477 33.6556 23.5586 32.9122 23.5586 31.9972C23.5586 31.0823 24.3592 30.3389 25.3313 30.3389H30.455C31.4386 30.3389 32.2278 31.0823 32.2278 31.9972C32.2278 32.9122 31.4386 33.6556 30.455 33.6556ZM25.3313 31.4826C25.0225 31.4826 24.7823 31.7113 24.7823 31.9972C24.7823 32.2831 25.034 32.5119 25.3313 32.5119H30.455C30.7638 32.5119 31.004 32.2831 31.004 31.9972C31.004 31.7113 30.7524 31.4826 30.455 31.4826H25.3313Z",
    fill: "#05D484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarservices);
export default __webpack_public_path__ + "static/media/carservices.46c4b4aa.svg";
export { ForwardRef as ReactComponent };